var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main"},[_c('p',[_vm._v("© 2024 Gestion des livraisons CB Inc. v.1.0.2. Tous droits réservés")])])
}]

export { render, staticRenderFns }